import axios from "axios";
export class QuestionsService {
    static getQuestions() {
        return axios.get('/api/questions/')
            .then(response => response.data[0]);
    }
}
